var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQ = function SvgQ(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#604DBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1,
    d: "M7 12.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#604DBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.102 5.347a1.8 1.8 0 0 1 3.496.6c0 .998-1.334 1.632-1.751 1.799v.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#604DBC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.848 10.145h.004"
  })));
};
export { SvgQ as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTIuNUMxMC4wMzc2IDEyLjUgMTIuNSAxMC4wMzc2IDEyLjUgN0MxMi41IDMuOTYyNDMgMTAuMDM3NiAxLjUgNyAxLjVDMy45NjI0MyAxLjUgMS41IDMuOTYyNDMgMS41IDdDMS41IDEwLjAzNzYgMy45NjI0MyAxMi41IDcgMTIuNVoiIHN0cm9rZT0iIzYwNERCQyIgc3Ryb2tlLXdpZHRoPSIxLjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4xMDE1NiA1LjM0NjdDNS4yNDI1NiA0Ljk0NTg3IDUuNTIwODcgNC42MDc4OCA1Ljg4NzIgNC4zOTI1OUM2LjI1MzUyIDQuMTc3MyA2LjY4NDIyIDQuMDk4NiA3LjEwMzAxIDQuMTcwNDNDNy41MjE4IDQuMjQyMjcgNy45MDE2NSA0LjQ2IDguMTc1MjkgNC43ODUwNkM4LjQ0ODkzIDUuMTEwMTIgOC41OTg2OSA1LjUyMTU0IDguNTk4MDYgNS45NDY0NEM4LjU5ODA2IDYuOTQ1MzEgNy4yNjQyIDcuNTc4NiA2Ljg0NjgzIDcuNzQ1NjZWOC4zNDU0IiBzdHJva2U9IiM2MDREQkMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi44NDc2NiAxMC4xNDQ1SDYuODUyMzYiIHN0cm9rZT0iIzYwNERCQyIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";